import React from 'react';

import {
  Skeleton,
  Content,
  ProductsArea,
  ProductPlaceholder,
  Sort,
  FlexColumn,
  Widget,
  Filter,
  Title,
} from './styles';

//constants
const DEFAULT_PAGE_SIZE = 12;
const PagePlaceholder = () => {
  return (
    <Skeleton>
      <Widget />
      <Title />
      <Content>
        <Filter />
        <FlexColumn>
          <Sort />
          <ProductsArea>
            {Array(DEFAULT_PAGE_SIZE)
              .fill('_')
              .map((_, index) => (
                <ProductPlaceholder key={index}></ProductPlaceholder>
              ))}
          </ProductsArea>
        </FlexColumn>
      </Content>
    </Skeleton>
  );
};

export default PagePlaceholder;
